import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React, { Fragment } from "react";
import { OrderButton } from "./styles";
import { OrderButtonsSpecific } from "./types";

type Props = OrderButtonsSpecific;

const DesktopOrderButtons = ({
  isAscendingActive,
  isDescendingActive,
  descendingCallback,
  ascendingCallback,
}: Props) => (
  <Fragment>
    <OrderButton
      data-cy="ascending-order-button"
      active={!!isAscendingActive}
      onClick={ascendingCallback}
      type="button"
    >
      <ExpandLess />
    </OrderButton>
    <OrderButton
      data-cy="descending-order-button"
      active={!!isDescendingActive}
      onClick={descendingCallback}
      type="button"
    >
      <ExpandMore />
    </OrderButton>
  </Fragment>
);

export default DesktopOrderButtons;
